<template>
  <div class="warning-notice">
    <div class="background" />
    <div class="main">
      <p class="hold">⚠️Warning: Please Acknowledge⚠️</p>
      <p>There is a problem with your account:</p>
      <p class="has-text-weight-bold" style="padding: 12px 0">
        {{ warningNotice }}
      </p>
      <!-- <p>ontact us if you would like to remove this warning.</p> -->
      <p class="buttons" style="margin: 16px 0">
        <span class="button is-capitalized pulse" @click="close"
          ><i class="fa fa-check-double" />&nbsp;I Acknowledge</span
        >
        <span class="button is-capitalized pulse" @click="emailAboutWarning"
          ><i class="far fa-envelope" />&nbsp;Remove Warning</span
        >
      </p>
    </div>
  </div>
</template>


<script>
export default {
  name: "WarningNotice",
  data() {
    return {};
  },
  computed: {
    warningNotice() {
      return this.$store.state.user.data.warning_notice;
    },
    phone() {
      return this.$store.getters.phoneNumber;
    },
    nameAndNumber() {
      return this.$store.getters.getNameAndNumber;
    },
  },
  mounted() {
    var msg = `CUSTOMER WARNING: ${this.nameAndNumber} ${this.warningNotice}`;
    this.sendSuperuserNotification(msg);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // contactChatSupport() {
    //   this.successToast("Opening TUK Messenger Chat...", "top");
    //   this.contactFBMessengerSupport();
    // },
    emailAboutWarning() {
      var email = "bizdev@tukapp.co";
      var subject = `Account Warning ${this.phone}: ${this.warningNotice}`;
      window.location.href = `mailto:${email}?subject=${subject}`;
      this.close();
    },
  },
};
</script>

<style scoped>
.warning-notice {
  position: relative;
  z-index: 999999;
}
.background {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
}
.main {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 20px;
  /* padding-bottom: 40px; */
  /* border: 6px solid yellow; */
  background-color: rgb(255, 78, 78);
  text-align: left;
}
.hold {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 1.2em;
}
.pulse {
  animation: shadow-pulse 2s ease-out infinite;
  border-radius: 3px;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 0, 0, 0.7);
  }
  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 0, 0, 1);
  }
}
</style>